import { Code, FileJson, Lock, Link, Palette, FileText, Hash, Key, Clock, Fingerprint } from 'lucide-react';

export const tools = [
  {
    id: 'json-formatter',
    name: 'JSON Formatter',
    description: 'Format, validate and beautify JSON data with syntax highlighting',
    icon: FileJson,
    category: 'Formatter',
    path: '/tools/json-formatter'
  },
  {
    id: 'base64-encoder',
    name: 'Base64 Encoder/Decoder',
    description: 'Encode or decode Base64 strings quickly and easily',
    icon: Lock,
    category: 'Encoder',
    path: '/tools/base64-encoder'
  },
  {
    id: 'url-encoder',
    name: 'URL Encoder/Decoder',
    description: 'Encode or decode URLs for safe transmission',
    icon: Link,
    category: 'Encoder',
    path: '/tools/url-encoder'
  },
  {
    id: 'color-picker',
    name: 'Color Picker',
    description: 'Pick colors and get HEX, RGB, HSL values instantly',
    icon: Palette,
    category: 'Design',
    path: '/tools/color-picker'
  },
  {
    id: 'hash-generator',
    name: 'Hash Generator',
    description: 'Generate MD5, SHA-1, SHA-256 hashes for your text',
    icon: Hash,
    category: 'Security',
    path: '/tools/hash-generator'
  },
  {
    id: 'jwt-decoder',
    name: 'JWT Decoder',
    description: 'Decode and verify JSON Web Tokens',
    icon: Key,
    category: 'Security',
    path: '/tools/jwt-decoder'
  },
  {
    id: 'lorem-ipsum',
    name: 'Lorem Ipsum Generator',
    description: 'Generate placeholder text for your designs',
    icon: FileText,
    category: 'Content',
    path: '/tools/lorem-ipsum'
  },
  {
    id: 'markdown-preview',
    name: 'Markdown Preview',
    description: 'Write and preview Markdown in real-time',
    icon: Code,
    category: 'Content',
    path: '/tools/markdown-preview'
  },
  {
    id: 'uuid-generator',
    name: 'UUID Generator',
    description: 'Generate unique identifiers (UUID v4)',
    icon: Fingerprint,
    category: 'Generator',
    path: '/tools/uuid-generator'
  },
  {
    id: 'timestamp-converter',
    name: 'Timestamp Converter',
    description: 'Convert between Unix timestamp and human-readable date',
    icon: Clock,
    category: 'Converter',
    path: '/tools/timestamp-converter'
  }
];

export const features = [
  {
    title: 'Lightning Fast',
    description: 'All tools run client-side for instant results',
    icon: '⚡'
  },
  {
    title: 'Secure & Private',
    description: 'Your data never leaves your browser',
    icon: '🔒'
  },
  {
    title: 'Free Forever',
    description: 'All tools are completely free to use',
    icon: '💎'
  },
  {
    title: 'SEO Optimized',
    description: 'Built with best practices for search engines',
    icon: '🚀'
  },
  {
    title: 'Mobile Friendly',
    description: 'Works perfectly on all devices',
    icon: '📱'
  },
  {
    title: 'No Sign Up',
    description: 'Start using tools immediately',
    icon: '✨'
  }
];

export const testimonials = [
  {
    name: 'Alex Johnson',
    role: 'Full Stack Developer',
    content: 'These tools save me hours every week. The JSON formatter is my go-to!',
    avatar: 'AJ'
  },
  {
    name: 'Sarah Chen',
    role: 'Frontend Engineer',
    content: 'Clean, fast, and reliable. Exactly what developers need.',
    avatar: 'SC'
  },
  {
    name: 'Mike Rodriguez',
    role: 'DevOps Engineer',
    content: 'The hash generator and Base64 tools are essential for my daily work.',
    avatar: 'MR'
  }
];